// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1MJDC","title":"Header_title__1TR-t","side":"Header_side__1WyAx"};